import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { Box, Typography } from '@mui/material';
import { PeriodEnum } from 'common/defines/clients';
import { FC } from 'react';
import ContainerBox from './ContainerBox';

interface ComparisonItemProps {
  label: string;
  averageValue: number;
  comparedValue: number;
  selectedPeriod: PeriodEnum;
}

const ComparisonItem: FC<ComparisonItemProps> = ({ label, comparedValue, averageValue, selectedPeriod }) => {
  const isUpwardData = comparedValue >= (averageValue || 0);

  const percent = isUpwardData ? (comparedValue / averageValue - 1) * 100 : (averageValue / comparedValue - 1) * 100;
  const displayedPercent = (!isNaN(percent) ? percent : 0).toFixed(0);

  return (
    <ContainerBox sx={{ py: '12px', px: '6px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <Box display="flex" gap="4px" alignItems="center" height="42px">
        <Box
          sx={{
            backgroundColor: (theme) => theme.palette.color.grey2,
            borderRadius: '50%',
            height: '20px',
            minWidth: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <ShowChartIcon sx={{ color: 'white', fontSize: '16px' }} />
        </Box>
        <Typography fontSize="14px" fontWeight={500}>
          {label}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap="0px">
        <Typography fontSize="28px" fontWeight={500}>
          {comparedValue.toFixed(2)}
        </Typography>
        <Box display="flex" alignItems="center">
          {isUpwardData ? <ArrowUpwardIcon sx={{ color: 'green' }} /> : <ArrowDownwardIcon sx={{ color: 'red' }} />}
          <Box component="span" color={isUpwardData ? 'green' : 'red'}>
            <Box component="span" fontSize="22px" fontWeight={500}>
              {displayedPercent}
            </Box>
            <Box component="span" fontWeight={500}>
              %&nbsp;
            </Box>
            <Box component="span" fontWeight={700}>
              vs last {selectedPeriod}
            </Box>
          </Box>
        </Box>
      </Box>
    </ContainerBox>
  );
};

export default ComparisonItem;
